/**
 * @module oauth/fetchConfigToken
 *
 * @fileOverview Makes a request to the backend to bootstrap the oAuth process.
 * Sends the client's ID and secret, used in a `client_credentials` grant type,
 * with scope `config_read`.
 *
 * (These should also be valid for `config_write`, but let's not have that kind
 * of power in the frontend app.)
 *
 * This should be the only file in the entire project importing Axios directly.
 */

import axios from 'axios'

import {
  apiUrl,
  oAuthClientId,
  oAuthClientSecret,
  requestTimeout,
} from '@/data/appConfig'

export default function fetchConfigToken() {
  const requestPayload = [
    `client_id=${oAuthClientId}`,
    `client_secret=${oAuthClientSecret}`,
    'grant_type=client_credentials',
    'scope=config_read postcode_read definition_read promotion_code_validate one_time_login',
  ].join('&')

  return axios.post(`${apiUrl}/auth/token`, requestPayload, {
    timeout: requestTimeout,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
}
